import React from "react";
import ReactDOM from "react-dom";
import {
  MegadraftEditor, editorStateFromRaw, editorStateToJSON
} from "megadraft";

class TextArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: editorStateFromRaw(JSON.parse(this.props.draftJS))
    };
  }

  onChange = (editorState) => {
    // change editor state
    this.setState({editorState});
    // change textarea content
    const content = editorStateToJSON(editorState);
    const textAreaUpdate = document.querySelector(
      `#${this.props.textAreaUpdate}`
    )
    textAreaUpdate.innerHTML = content
  }

  render() {
    return (
      <MegadraftEditor
        editorState={this.state.editorState}
        onChange={this.onChange} />
    )
  }
}

export default TextArea
